import React from "react";
import type { SectionKey } from "./manageRetreatTypes";
import styles from "./retreatDashboardChrome.module.scss";

function StatusCard({
  label,
  value,
  detail,
  color,
  onClick,
}: {
  label: string;
  value: number;
  detail: string;
  color: string;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      className={styles.kpiCard}
      style={{ ["--kpi-color"]: color } as React.CSSProperties}
      aria-label={`Go to ${label} section`}
      onClick={onClick}
    >
      <span className={styles.kpiValue}>{value}</span>
      <span className={styles.kpiCopy}>
        <span className={styles.kpiLabel}>{label}</span>
        <span className={styles.kpiDetail}>{detail}</span>
      </span>
    </button>
  );
}

export function ManageRetreatKpis({
  isSuperAdmin,
  counts,
  onScrollTo,
}: {
  isSuperAdmin: boolean;
  counts: Record<SectionKey, number>;
  onScrollTo: (key: SectionKey) => void;
}) {
  return (
    <nav
      className={isSuperAdmin ? styles.kpiNavFour : styles.kpiNavThree}
      aria-label="Retreat status section navigation"
    >
      {isSuperAdmin && (
        <StatusCard
          label="Projected"
          value={counts.projected}
          detail="Executive portfolio"
          color="#4f6f8d"
          onClick={() => onScrollTo("projected")}
        />
      )}
      <StatusCard
        label="In Setup"
        value={counts.inSetup}
        detail="Publication readiness"
        color="#c18418"
        onClick={() => onScrollTo("inSetup")}
      />
      <StatusCard
        label="Registration Open"
        value={counts.registrationOpen}
        detail="Active public pages"
        color="#1670bf"
        onClick={() => onScrollTo("registrationOpen")}
      />
      <StatusCard
        label="Post-Retreat Closing"
        value={counts.closing}
        detail="Closure and access"
        color="#71438d"
        onClick={() => onScrollTo("closing")}
      />
    </nav>
  );
}
